"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.APosCategoryUpdateInputSchema = exports.APosCategoryCreateInputSchema = exports.APosCategorySchema = exports.APosOnlineTakedownSchema = exports.APosCategoryStatusSchema = void 0;
const zod_1 = require("zod");
const timestamps_schema_1 = require("../../common/timestamps.schema");
const id_schema_1 = require("../../common/id.schema");
exports.APosCategoryStatusSchema = zod_1.z.enum(['active', 'inactive', 'deleted']);
// Online takedown — pulls a category's variants out of online/marketplace indexes
// without touching the retail POS index. scope = which non-retail surfaces it affects.
exports.APosOnlineTakedownSchema = zod_1.z.object({
    active: zod_1.z.boolean().default(false),
    reason: zod_1.z.string().max(500).optional(),
    scope: zod_1.z.enum(['own-site', 'marketplace', 'both']).default('both'),
});
exports.APosCategorySchema = zod_1.z.object({
    tenantId: id_schema_1.TenantIdSchema,
    categoryId: id_schema_1.EntityIdSchema,
    name: zod_1.z.string().min(1).max(100),
    slug: zod_1.z.string().min(1).max(100),
    description: zod_1.z.string().max(500).optional(),
    parentCategoryId: zod_1.z.string().nullable().default(null),
    path: zod_1.z.string().min(1).describe('Materialized path'),
    level: zod_1.z.number().int().nonnegative(),
    sortOrder: zod_1.z.number().int().nonnegative().default(0),
    imageUrl: zod_1.z.string().url().optional(),
    imageKey: zod_1.z.string().optional(),
    productCount: zod_1.z.number().int().nonnegative().default(0),
    activeProductCount: zod_1.z.number().int().nonnegative().default(0),
    displayOnStorefront: zod_1.z.boolean().default(true),
    displayOnPOS: zod_1.z.boolean().default(true),
    displayOnB2B: zod_1.z.boolean().default(false),
    status: exports.APosCategoryStatusSchema.default('active'),
    onlineTakedown: exports.APosOnlineTakedownSchema.optional(),
}).merge(timestamps_schema_1.TimestampsSchema);
exports.APosCategoryCreateInputSchema = zod_1.z.object({
    name: zod_1.z.string().min(1).max(100),
    slug: zod_1.z.string().min(1).max(100),
    description: zod_1.z.string().max(500).optional(),
    parentCategoryId: zod_1.z.string().nullable().optional(),
    sortOrder: zod_1.z.number().int().nonnegative().optional(),
    imageUrl: zod_1.z.string().url().optional(),
    imageKey: zod_1.z.string().optional(),
    displayOnStorefront: zod_1.z.boolean().optional(),
    displayOnPOS: zod_1.z.boolean().optional(),
    displayOnB2B: zod_1.z.boolean().optional(),
});
exports.APosCategoryUpdateInputSchema = exports.APosCategoryCreateInputSchema.partial().extend({
    status: exports.APosCategoryStatusSchema.optional(),
    onlineTakedown: exports.APosOnlineTakedownSchema.optional(),
});
//# sourceMappingURL=category.schema.js.map